export default "//static.tradera.net/touchweb/static/output/images/category-vehicles-boats-parts.bd498b6e.svg";